import { render } from "./List.vue?vue&type=template&id=2acf03bb&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=2acf03bb&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2acf03bb"

export default script